//Iframe Desktop
var btnVimeo = $('.btn-vimeo-default'),
    btnVimeoMobile = $('.btn-vimeo-mobile');
var options = {
    id: '116582567',
    width: '800',
    height: '900',
    controls: false
}

$(document).on('click', '.btn-vimeo-default', function () {
    
    var self__ = $(this);
    var iframe1 = self__.parent().find('#vimeoID1');
    var player1 = new Vimeo.Player(iframe1, options);
    
    if (self__.hasClass('btn-play')) {
        self__.removeClass('btn-play icon-play-video-action').addClass('btn-pause icon-pause-video-action');
        player1.play();
    }
    else {
        self__.removeClass('btn-pause icon-pause-video-action').addClass('btn-play icon-play-video-action');
        player1.pause();

    }
});

//Iframe Mobile
$(document).on('click', '.btn-vimeo-mobile', function () {

    var self__ = $(this);
    var iframe2 = self__.parent().find('#vimeoID2');
    var player2 = new Vimeo.Player(iframe2, options);

    if (self__.hasClass('btn-play')) {
        self__.removeClass('btn-play icon-play-video-action').addClass('btn-pause icon-pause-video-action');
        player2.play();
    }
    else {
        self__.removeClass('btn-pause icon-pause-video-action').addClass('btn-play icon-play-video-action');
        player2.pause();

    }
});


$('.video-desktop-exist').each(function() {
    $(this).parents(':eq(3)').addClass('exist-video-desktop')
});
$('.video-mobile-exist').each(function() {
    $(this).parents(':eq(3)').addClass('exist-video-mobile')
});

// Find all viemo videos
$( document ).ready(function() {
    var window_width = $(window).width();
    if (window_width > 768) { 
        //do something 
        $('.video-desktop').each(function(i,iframe){
            var url = "https://vimeo.com/api/oembed.json?url=https://www.vimeo.com/"+$(iframe).data("video-id")
        
            $.get(url,{}, function(d){
        
                var ratio = d.height/d.width;
                var newWidth = $(iframe).width();

                $(iframe).height(newWidth * ratio);

                var videoSliderHeight = $(iframe).height();

                $('.slider-caroussel .slick-track').each(function() {
                    if ($(this).hasClass('exist-video-desktop')) {
                        $(this).find('.common-image-component').css('height', videoSliderHeight);
                        $(this).parents(':eq(6)').closest('.region').css('height', videoSliderHeight);
                    } else {
                        var heightImage = $(this).find('.common-image-component').height();
                        $(this).parents(':eq(6)').closest('.region').css('height',  heightImage);
                    }
                  });
        
            });
        
        });
        
    }else{
        $('.video-mobile').each(function () {
            var video_Height = (window_width * 1.45);
            $(this).parent().css('height', video_Height);
        });
    }
});

$(document).ready(function () {
    var window_width = $(window).width();
    var window_height = $(window).outerHeight();
    var hauteur_fenetre = $('header').outerHeight();
    var heightImageSlider = window_height - hauteur_fenetre;
    var videoSliderHeight = $('.slider-caroussel .video-mobile').height();
    if (window_width < 768 ) {
        $('.slider-caroussel .slick-track').each(function() {
            if ($(this).hasClass('exist-video-mobile')) {
                $(this).find('.common-image-component').css('height', videoSliderHeight);
                $('.experience-tkooples_layouts-SKPSliderBlock').parent().closest('.region').css('height', videoSliderHeight);
            } else {
                $(this).find('.common-image-component').css('height', heightImageSlider);
                $('.experience-tkooples_layouts-SKPSliderBlock').parent().closest('.region').css('height', heightImageSlider);
            }
          });
    }
});